import { useRouteLoaderData } from "react-router";

import { useBackgroundError } from "~/hooks/useBackgroundError";
import type { EventLoaderData } from "~/loaders/event";

import { useGetNewsByIdQuery } from "./newsApi";

export const useEventNews = (eventId: string) => {
  const initialFeed =
    (useRouteLoaderData("routes/event") as EventLoaderData | undefined)?.news ??
    undefined;

  const { data, isLoading, isFetching, error } = useGetNewsByIdQuery({
    id: eventId,
  });

  useBackgroundError(error);

  const feed = error ? undefined : (data ?? initialFeed);

  return { feed, isLoading: (isLoading || isFetching) && !feed };
};
